import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  BarChart3,
  Map as MapIcon,
  TrendingUp,
  LogOut,
  FileText,
  UserPlus, // ✅ NEW ICON FOR REGISTER
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const Sidebar = ({ onSelect }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [activeItem, setActiveItem] = useState("Dashboard");

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleSelect = (item) => {
    setActiveItem(item);
    if (typeof onSelect === "function") onSelect(item);
  };

  // ✅ UPDATED ORDER: Register is AFTER Map
  const menuItems = [
    { name: "Dashboard", icon: BarChart3 },
    { name: "Map", icon: MapIcon },
    { name: "Register", icon: UserPlus }, // ✅ ADDED HERE
    { name: "Reports", icon: FileText },
    { name: "Analysis", icon: TrendingUp },
  ];

  const sidebarShell = {
    height: "100vh",
    width: "280px",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'Poppins', sans-serif",

    background: "rgba(255, 255, 255, 0.14)",
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
    borderRight: "1px solid rgba(255, 255, 255, 0.20)",

    position: "sticky",
    top: 0,
    zIndex: 9999,
    pointerEvents: "auto",
  };

  return (
    <div style={sidebarShell}>
      {/* HEADER */}
      <div style={{ padding: "24px 20px", borderBottom: "1px solid rgba(255,255,255,0.20)" }}>
        <div style={{ fontSize: "30px", fontWeight: 600, color: "#0f172a", textAlign: "center" }}>
          L.I.S.A.
        </div>
        <div style={{ fontSize: 12, color: "rgba(15,23,42,0.65)", textAlign: "center", marginTop: 6 }}>
          Admin Panel
        </div>
      </div>

      {/* NAVIGATION */}
      <div style={{ flex: 1, padding: "16px 20px" }}>
        {menuItems.map((item) => (
          <button
            key={item.name}
            type="button"
            onClick={() => handleSelect(item.name)}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              padding: "12px 16px",
              marginBottom: "6px",
              border: "1px solid rgba(255,255,255,0.18)",
              borderRadius: "12px",
              background:
                activeItem === item.name
                  ? "rgba(16, 185, 129, 0.18)"
                  : "rgba(255,255,255,0.10)",
              color:
                activeItem === item.name
                  ? "#065f46"
                  : "rgba(15,23,42,0.80)",
              cursor: "pointer",
              transition: "all 0.15s ease",
              textAlign: "left",
              boxShadow:
                activeItem === item.name
                  ? "0 10px 25px rgba(0,0,0,0.10)"
                  : "none",
            }}
            onMouseEnter={(e) => {
              if (activeItem !== item.name) {
                e.currentTarget.style.background = "rgba(255,255,255,0.18)";
              }
            }}
            onMouseLeave={(e) => {
              if (activeItem !== item.name) {
                e.currentTarget.style.background = "rgba(255,255,255,0.10)";
              }
            }}
          >
            <item.icon
              size={18}
              style={{
                marginRight: 12,
                opacity: activeItem === item.name ? 1 : 0.85,
                color:
                  activeItem === item.name
                    ? "#059669"
                    : "rgba(15,23,42,0.70)",
              }}
            />
            {item.name}
          </button>
        ))}
      </div>

      {/* LOGOUT */}
      <div style={{ padding: 20, borderTop: "1px solid rgba(255,255,255,0.20)" }}>
        <Button
          type="button"
          onClick={handleLogout}
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "12px 16px",
            background: "rgba(239, 68, 68, 0.14)",
            border: "1px solid rgba(239, 68, 68, 0.25)",
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 600,
            color: "#b91c1c",
            cursor: "pointer",
          }}
        >
          <LogOut size={16} style={{ marginRight: 12 }} />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;